<template>
  <div class="com_leaders_info">
    <div v-for="(leader,index) in leaderArr" :key="index" class="com_leader_cup">
      <div class="leader_img">
        <img :src="leader.icon" alt="" width="146" height="167">
      </div>
      <div class="leader_info">
        <p class="leader_summary" v-html="leader.summary"></p>
      </div>
    </div>
  </div>
</template>
<script>
import { leadersCompany } from '@/api/enFrontApi/company';
export default {
  data() {
    return {
      leaderArr: []
    };
  },
  created() {
    this.initLeaders();
  },
  methods: {
    initLeaders() {
      this.leaderArr = [];
      leadersCompany().then(res => {
        if (res.data.length) {
          res.data.forEach(item => {
            let tempObj = {
              icon: '',
              name: '',
              jobTitle: '',
              summary: ''
            };
            tempObj.icon = item.leadImg;
            tempObj.name = item.leadName;
            tempObj.jobTitle = item.leadImg;
            tempObj.summary = item.leadBody;
            this.leaderArr.push(tempObj);
          });
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.com_leader_cup {
  border: 1px solid #DCDFE6;
  padding: 10px 10px;
  margin-bottom: 10px;
  font-size: 16px;
  overflow: hidden;
  width: 100%;
  height: 180px;
  line-height: 180px;
  min-width: 680px;

  .leader_img {
    float: left;
    margin-right: 10px;
    width: 18%;
    min-width: 150px;
  }

  .leader_info {
    float: left;
    width: 75%;
    min-width: 450px;
  }

  .leader_summary {
    color: #000;
    padding-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5; /* 第5行显示 ... */
    -webkit-box-orient: vertical;
  }

  .leader_summary>>>p {
    color: #000;
    line-height: 20px;
    height: 20px;
  }

  img {
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/companyInfos/companyLeaders.vue